import $ from 'jquery';
// import "slick-carousel";
// import TweenMax from "gsap";

$(window).on("scroll", function() {
  scrollAnime();
});
$(window).on("resize", function() {
  scrollAnime();
});
$(window).on("load", function() {
  $(".loading").fadeOut(600, function() {
    $(".container").css("opacity", "1");
    scrollAnime();
  });
  $(".nav_link[data-id='" + $("body").data("id") + "']").addClass("active");

});

// スクローラー
$('a.scroller[href^="#"]').on("click", function() {
  var target = $($(this).attr("href"));
  var position = target.offset().top;

  $('body,html').stop().animate({
    scrollTop: position
  }, 500);
  return false;
});

$('.modal_dialog_close, .modal_bg').click(function() {
  $(".modal, .modal_dialog").fadeOut(300, function() {
  });
});
$('.openModal').click(function() {
  var no = $(this).data("no");
  $(".modal_dialog_slot_inner, .modal_dialog_slider").removeClass("active")

  $(".modal").fadeIn(300, function() {

    $(".modal_dialog[data-no='" + no + "']").fadeIn(300);
    if (99 == no) {
      setTimeout(function() {
        $(".modal_dialog_slot_inner").addClass("active");
      }, 100);
      $('.modal_dialog_sliderWrap').slick('slickNext');

      setTimeout(function() {
        $(".modal_dialog_slider").addClass("active");
      }, 700);

    }
  });
});

// フェードイン アニメーション
function scrollAnime() {
  var windowHeight = $(window).innerHeight(),
    windowWidth = $(window).innerWidth(),
    topWindow = $(document).scrollTop(),
    docHeight = $(document).innerHeight(),
    fadeH = 300
    ;

  $('.fadein, .slidein').each(function() {
    var targetPosition = $(this).offset().top;

    fadeH = $(this).data("fadeheight") != undefined ? $(this).data("fadeheight") : fadeH;

    if (topWindow > targetPosition - windowHeight + (fadeH) || $(this).data("first") == 1) {
      $(this).addClass($(this).data("fadein"));
    }
  });
}
